<template>
  <div>
    <div class="header">
      <div class="title_box">
        <h1 class="title">{{ this.$props.title }}</h1>
        <p class="count">Total: {{ totalLength }} <span v-if="totalDetails">{{ totalDetails }}</span></p>
      </div>

      <button class="button" @click="handleAddClick">
        <svg class="icon">
          <use xlink:href="@/assets/img/link_plus.svg#plus"></use>
        </svg>

        <span>Add</span>
      </button>
    </div>

    <div v-show="!hidePagination" class="pagination_box">
      <Pagination
        @updateVisibleData="handleVisibleUpdate"
        :allDataLength="totalLength"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "./Pagination.vue";

const PER_PAGE = 10;

export default {
  components: {
    Pagination,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    totalDetails: {
      type: String,
      required: false,
    }
  },
  data() {
    return {};
  },
  methods: {
    handleAddClick() {
      this.$emit("addClick");
    },
    handleVisibleUpdate(data) {
      this.$emit("updateVisible", data);
    },
  },
  computed: {
    totalLength() {
      return this.$props.total;
    },

    hidePagination() {
      return Math.ceil(this.totalLength / PER_PAGE) < 2;
    },
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: flex;
  align-items: baseline;
  gap: 32px;

  @media screen and (max-width: 768px) {
    justify-content: space-between;
    margin-bottom: 32px;
  }
}

.title {
  padding: 0;
  margin: 0;
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.header {
  padding: 0;
  margin: 0 0 32px 0;
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    justify-content: center;
    flex-direction: column;
  }
}

.pagination_box {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;

  @media screen and (max-width: 768px) {
    justify-content: center;
    margin-bottom: 16px;
  }
}

.hide {
  margin-bottom: 0;
}

.count {
  padding: 0;
  margin: 0;
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
}

.actions {
  display: flex;
  align-items: center;
  gap: 32px;
}

.button {
  display: flex;
  width: 116px;
  height: 38px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  border: 1px solid #3056d3;
  background: transparent;
  transition: all ease-in-out 300ms;
  color: #3056d3;
  fill: #3056d3;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;

  &:hover:not(:disabled) {
    color: #fff;
    fill: #fff;
    border-color: #3056d3;
    background-color: #3056d3;
  }

  &:disabled {
    opacity: 0.5;
  }
}

.icon {
  fill: inherit;
  width: 28px;
  height: 28px;
}
</style>
